module.exports = __webpack_public_path__ + "img/file-view-ico.62ded78.svg";